import { Modal } from 'antd';

import styled from 'styled-components';

export const ModalContainer = styled(Modal)<{ isConfirm?: boolean }>`
  .ant-modal-body {
    ${({ isConfirm }) => (isConfirm ? '' : 'height: auto')};
    overflow-y: auto;
  }
`;

export const Item = styled.div`
  display: flex;
  margin-bottom: 24px;
  color: #202020;
  font-size: 14px;
  font-weight: 500;

  &.items {
    margin-bottom: 24px;
  }

  .ant-input-disabled {
    color: #202020;
  }
`;
